import type { RouteRecordRaw } from 'vue-router'

export const receiverRoutes: RouteRecordRaw[] = [
  {
    path: '/templates',
    component: () => import('layouts/receiver/MainLayout.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'manage-templates',
        component: () =>
          import('pages/receiver/templates/manage/ManageTemplates.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'create',
        name: 'create-template',
        component: () => import('pages/receiver/templates/CreateTemplate.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'edit/:templateId/:type',
        name: 'edit-template',
        component: () =>
          import('pages/receiver/templates/manage/EditTemplate.vue'),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      {
        path: 'edit/:templateId/custom-format',
        name: 'template-custom-format',
        component: () =>
          import('pages/receiver/templates/manage/CustomFormat.vue'),
        meta: {
          requiresAuth: true,
          fluid: 'container-xxl',
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      // COLUMNS
      {
        path: 'columns/:templateId',
        name: 'manage-template-columns',
        component: () =>
          import(
            'pages/receiver/templates/manage/columns/ManageTemplateColumns.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      {
        path: 'columns/:templateId/bulk',
        name: 'import-template-columns',
        component: () =>
          import(
            'pages/receiver/templates/manage/columns/BulkImportColumns.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
          fluid: 'container-xxl',
        },
      },
      {
        path: 'columns/:templateId/bulk/:importId',
        name: 'import-template-columns-report',
        component: () =>
          import(
            'pages/receiver/templates/manage/columns/BulkImportColumnReport.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      {
        path: 'columns/:templateId/bulk-constraints',
        name: 'import-constraints',
        component: () =>
          import(
            'pages/receiver/templates/manage/columns/BulkImportConstraints.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
          fluid: 'container-xxl',
        },
      },
      {
        path: 'columns/:templateId/bulk-constraints/:importId',
        name: 'import-constraints-report',
        component: () =>
          import(
            'pages/receiver/templates/manage/columns/BulkImportConstraintsReport.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      // VALUES LISTS
      {
        path: 'value-list/:templateId',
        name: 'manage-values-lists',
        component: () =>
          import(
            'pages/receiver/templates/manage/valuesLists/ManageValuesLists.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      {
        path: 'value-list/:templateId/bulk-import',
        name: 'import-values-lists',
        component: () =>
          import(
            'pages/receiver/templates/manage/valuesLists/BulkImportValueList.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
          fluid: 'container-xxl',
        },
      },
      {
        path: 'value-list/:templateId/bulk-import/:importId',
        name: 'import-values-lists-report',
        component: () =>
          import(
            'pages/receiver/templates/manage/valuesLists/BulkImportValueListReport.vue'
          ),
        meta: {
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
      // RULES
      {
        path: 'rules/:templateId',
        name: 'template-rules',
        component: () =>
          import(
            'pages/receiver/templates/manage/rules/TemplateDefaultRules.vue'
          ),
        meta: {
          fluid: 'container-xxl',
          requiresAuth: true,
          oneOfRoles: ['ORGANISATION_TEMPLATES', 'TM_'],
        },
      },
    ],
  },
]
